/* NotFound.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from 'react';
import { ErrorTemplate } from '../ErrorTemplate';
import { locale } from '../locale';
import { RedirectLink } from '../RedirectLinks';
import NotFoundSvg from './NotFound.svg';
const _3 = "._1tke1kw7{min-height:inherit}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const NotFoundWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _1tke1kw7", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  NotFoundWrapper.displayName = 'NotFoundWrapper';
}
export const NotFound = () => {
  return /*#__PURE__*/React.createElement(NotFoundWrapper, null, /*#__PURE__*/React.createElement(ErrorTemplate, {
    heading: locale.notFound.heading,
    image: NotFoundSvg
  }, /*#__PURE__*/React.createElement("span", null, locale.notFound.pageNotExist, " ", /*#__PURE__*/React.createElement(RedirectLink, {
    href: "/"
  }, locale.homePage))));
};